import { parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
export const useConvertFlightOverviewData = flights => {
  if (!flights || flights.length === 0) {
    return [];
  }
  return flights.map(flight => ({
    ...flight,
    departureDateTime: String(toZonedTime(parseISO(flight.departureDateTime), 'UTC')),
    arrivalDateTime: String(toZonedTime(parseISO(flight.arrivalDateTime), 'UTC'))
  }));
};